var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FormHelperText, makeStyles, styled, withStyles } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useLinked } from '@type-r/react';
import clsx from 'clsx';
import * as React from 'react';
import { useContext } from 'react';
import { useQaId } from './qa-ids';
import { colors, div } from '../common';
import { Flex } from '../flex';
import { BaseCheckbox } from './checkbox';
import { Input, ReadOnly } from './inputs';
import { BaseSelect } from './select';
import * as LqxLink from '../link';
import { Link } from '../link';
export var FormInput = function (_a) {
    var label = _a.label, trimOnBlur = _a.trimOnBlur, lqxId = _a["qa-id"], props = __rest(_a, ["label", "trimOnBlur", 'qa-id']);
    var classes = useTextFieldStyles(props), ro = useContext(ReadOnly) || props.readOnly || !props.$value || props.disabled, error = ro ? '' : props.$value.error;
    var onBlurCopy = props.onBlur;
    if (trimOnBlur) {
        props.onBlur = function (e) {
            if (props.$value && (typeof props.$value.value === 'string')) {
                var trimmedInput = props.$value.value.trim();
                props.$value.set(trimmedInput);
            }
            if (onBlurCopy) {
                onBlurCopy(e);
            }
        };
    }
    var nextId = useQaId(lqxId || label);
    return (React.createElement("label", { className: classes.root },
        React.createElement("span", { className: classes.label },
            label,
            (props.required === undefined && error === 'Required') || (props.required && !ro) ?
                React.createElement("span", { className: classes.required }, "*")
                : null),
        React.createElement("div", { className: classes.formControlInputWithError },
            React.createElement(Input, __assign({}, props, { "data-qa-id": nextId })),
            React.createElement(FormHelperText, null, error !== 'Required' ? error : ''))));
};
export var FormDisputeInput = function (_a) {
    var label = _a.label, value = _a.value, $value = _a.$value, props = __rest(_a, ["label", "value", "$value"]);
    var classes = useTextFieldStyles(), ro = useContext(ReadOnly) || props.readOnly || !$value, error = ro ? '' : $value.error, $initialValue = useLinked($value.value), 
    // not sure if we still have to cross out the value
    valueChanged = $value.value !== $initialValue.value;
    return (React.createElement("label", { className: classes.root },
        React.createElement("span", { className: clsx(classes.label, classes.disputeLabel) },
            label,
            error === 'Required' ?
                React.createElement("span", { className: classes.required }, "*")
                : null),
        React.createElement("div", { className: classes.disputeValueContainer },
            React.createElement(Input, __assign({ classes: {
                    input: valueChanged ?
                        clsx(classes.disputeValue, classes.disputeValueChanged)
                        :
                            classes.disputeValue
                } }, props, { readOnly: true, value: value, "$value": undefined }))),
        React.createElement("div", { className: classes.formControlInputWithError },
            React.createElement(Input, __assign({}, props, { value: undefined, "$value": $value })),
            React.createElement(FormHelperText, null, error !== 'Required' ? error : ''))));
};
export var FormLink = function (_a) {
    var label = _a.label, _b = _a.href, href = _b === void 0 ? undefined : _b, linkLabel = _a.linkLabel, _c = _a.onClick, onClick = _c === void 0 ? undefined : _c;
    var classes = useTextFieldStyles();
    return (React.createElement("label", { className: classes.root },
        React.createElement("span", { className: classes.label }, label),
        React.createElement("div", { className: classes.formControlInputWithError },
            React.createElement(Link, { className: classes.link, href: href, onClick: onClick }, linkLabel))));
};
/**
 * Take additional styles and trigger navigate event
 */
export var FormHyperlink = function (_a) {
    var label = _a.label, href = _a.href, linkLabel = _a.linkLabel, props = __rest(_a, ["label", "href", "linkLabel"]);
    var classes = useTextFieldStyles();
    return (React.createElement("label", { className: classes.root },
        React.createElement("span", { className: classes.label }, label),
        React.createElement("div", { className: classes.formControlInputWithError },
            React.createElement(LqxLink.AppLink, __assign({ className: classes.link, href: href }, props), linkLabel))));
};
var useTextFieldStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        color: '#767D84',
        fontFamily: 'Montserrat',
        fontSize: 12,
        fontWeight: 500,
        marginBottom: 8,
        '&:focus-within': {
            color: '#1084D3',
            fontWeight: 600,
        }
    },
    required: {
        color: colors.red,
        verticalAlign: 'middle',
        fontSize: 16,
        paddingLeft: 4,
    },
    label: {
        flex: 2,
        alignSelf: 'center',
    },
    disputeLabel: {
        flex: 4,
    },
    disputeValueContainer: {
        flex: 3,
        alignSelf: 'center',
    },
    disputeValue: {
        textAlign: 'left',
    },
    disputeValueChanged: {
        textDecoration: 'line-through'
    },
    formControlInputWithError: {
        flexDirection: 'column',
        flex: 3,
        display: 'inline-flex',
    },
    link: {
        textDecoration: 'none',
        padding: '4px 3px 3px 3px'
    }
});
export var FormLabel = div({
    fontFamily: 'Montserrat',
    flex: 2,
    color: '#767D84',
    alignSelf: 'center',
    fontSize: 12,
    fontWeight: 500,
});
export var FormSelect = withStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        color: '#767D84',
        fontFamily: 'Montserrat',
        fontSize: 12,
        fontWeight: 500,
        borderStyle: 'none',
        '&:focus-within': {
            fontWeight: 600,
        },
        '& .select-input-root': {
            flexGrow: 3,
        },
        '&.error': {
            '& .select-root': {
                border: 'none !important',
            },
            '& .select-input-root': {
                borderRadius: 2,
                border: '1px solid #FF274B !important',
            }
        },
    },
    label: {
        flex: 2,
        alignSelf: 'center',
    },
    selectRoot: {
        borderRadius: 2,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#E3E9ED',
        fontSize: 12,
        fontWeight: 500,
        flex: 3,
        display: 'inline-flex',
    },
    selectInputRoot: {
        flex: 1,
    },
    selectInput: {
        fontSize: 14,
        fontWeight: 500,
        '&:focus': {
            outline: 'none',
        },
        '&:disabled': {
            opacity: 0.5,
        }
    },
})(BaseSelect);
export var FormCheckbox = withStyles({
    label: {
        color: '#767D84',
        fontFamily: 'Montserrat',
        fontSize: 12,
        fontWeight: 500,
    },
    checkbox: {
        width: 24,
        height: 24,
        '& div': {
            width: 17,
            height: 9,
            margin: '5px 3px 3px 3px',
        },
    },
})(BaseCheckbox);
export var RoundCheckbox = withStyles({
    checkbox: {
        height: 17,
        width: 17,
        borderRadius: 10,
        borderColor: '#A0A0A0',
        '& div': {
            width: 9,
            height: 5,
        },
    },
})(BaseCheckbox);
export var SelectFile = styled(function (_a) {
    var className = _a.className, label = _a.label, $value = _a.$value, accept = _a.accept;
    return React.createElement("label", { className: className },
        React.createElement(FormLabel, null, label),
        React.createElement(Flex, { grow: true }),
        React.createElement("div", { className: "filename", title: $value.value ? $value.value.name : '' }, $value.value ?
            $value.value.name
            :
                'Click to select the file...'),
        React.createElement(CloudUploadIcon, null),
        React.createElement("input", { style: { display: 'none' }, type: "file", accept: accept, onChange: function (e) { return $value.set(e.target.files[0]); } }));
})({
    display: 'flex',
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#c4c4c4',
    borderStyle: 'solid',
    padding: 12,
    borderRadius: 4,
    alignItems: 'center',
    marginTop: 4,
    marginBottom: 4,
    '& .filename': {
        fontFamily: 'Montserrat',
        color: 'black',
        alignSelf: 'center',
        fontSize: 14,
        fontWeight: 500,
        marginRight: '1em',
        marginLeft: '1em',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    }
});
//# sourceMappingURL=horizontal.js.map